import { dsrFaqHeaders } from '../../../app/src/screens/DsrFaq/Faqs.js';

import ActionPanel from '../components/ActionPanel.jsx';
import ScreenHeader from '../components/ScreenHeader.jsx';
import { HELP_PATH, dsrFaqPath } from '../navigation/paths.js';

// The Demand Side Response FAQ list — the app's DsrFaq/List.js as a web page,
// built from the same exported question list, so a question added to the app
// appears here too. Pilot only, as in the app (the route is behind FlagGate).
export default function DsrFaqListScreen() {
  return (
    <main className="app-shell screen">
      <ScreenHeader
        title="Demand Side Response"
        sub="Support & FAQs"
        backTo={HELP_PATH}
        backLabel="Help"
      />
      <nav
        className="action-panel-list"
        aria-label="Demand Side Response questions"
      >
        {dsrFaqHeaders.map((question, index) => (
          <ActionPanel key={question} to={dsrFaqPath(index)} title={question} />
        ))}
      </nav>
    </main>
  );
}
